export const getCookie = (name: string): string | null => {
    if (typeof document !== "undefined" && document.cookie) {
        const cookieValue = document.cookie
          .split(";")
          .find((row) => row.trim().startsWith(name + "="));
        if (cookieValue) {
            return decodeURIComponent(cookieValue.split("=")[1]);
        }
    }
    if (typeof localStorage !== "undefined") {
        return localStorage.getItem(name);
    }
    return null;
};

export const setCookie = (name: string, value: string): void => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        const isHttps = window.location.protocol === "https:";
        const cookieAttributes = isHttps ? "; path=/; SameSite=None; Secure" : "; path=/; SameSite=Lax";
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}${cookieAttributes}`;
    }
    if (typeof localStorage !== "undefined") {
        localStorage.setItem(name, value);
    }
};

export const removeCookie = (cookieToRemove: string): void => {
    if (typeof document !== "undefined") {
        const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = `${cookieToRemove}=; expires=${expires}; path=/; SameSite=Lax`;
    }
    if (typeof localStorage !== "undefined") {
        localStorage.removeItem(cookieToRemove);
    }
};
